<template>
  <div id="e3" style="margin: auto;" class="grey lighten-3">
    <v-toolbar dark>
      <v-toolbar-title>{{ rider.name }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="loadRider">
        <v-icon>refresh</v-icon>
      </v-btn>
    </v-toolbar>
    <v-card>
      <v-container fluid>
        <v-layout justify-space-between row fill-height>
          <v-flex sm12>
            <v-card-title>
              <connection-manager
                ref="connectionManager"
                v-model="connecting"
                style="width: 100%; height: 50px"
              />
            </v-card-title>
            <v-card-title>
              <div>
                <v-switch
                  v-model="rider.active == 1"
                  :label="`${rider.active == 1 ? 'Active' : 'Inactive'}`"
                  @click="activateUser(rider.active == 1 ? 0 : 1)"
                  v-if="rider"
                ></v-switch>
              </div>
              <GmapMap
                :center="{ lat: lat, lng: lng }"
                :zoom="10"
                style="width: 100%; height: 300px"
                ref="mapRef"
              >
                <GmapMarker
                  :position="{ lat: lat, lng: lng }"
                  :clickable="true"
                  title="Last Known Location"
                  @click="center = { lat: lat, lng: lng }"
                />
              </GmapMap>
              <v-layout justify-space-between row fill-height>
                <v-flex sm12 pa-1>
                  <v-list>
                    <v-list-tile
                      v-for="item in rider.lastKnownLocations"
                      :key="item.id"
                      avatar
                      @click=""
                    >
                      <v-list-tile-action>
                        <v-chip color="primary" text-color="white">{{
                          item.createdAt
                        }}</v-chip>
                      </v-list-tile-action>

                      <v-list-tile-content>
                        <v-list-tile-title
                          v-text="item.placeName"
                        ></v-list-tile-title>
                        <v-list-tile-title
                          v-text="item.description"
                        ></v-list-tile-title>
                      </v-list-tile-content>
                    </v-list-tile>
                  </v-list>
                </v-flex>
              </v-layout>
            </v-card-title>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>
  </div>
</template>

<script>
import ConnectionManager from './ConnectionManager'
import { gmapApi } from 'vue2-google-maps'
export default {
  name: 'RiderSiderBar',
  props: ['latitude', 'longitude'],
  data() {
    return {
      connecting: false,
      rider: {},
      lat: 0,
      lng: 0,
      map: null,
      riderPath: null,
      loading: false
    }
  },
  components: { ConnectionManager },
  methods: {
    activateUser(active) {
      let that = this
      this.loading = true
      this.axios
        .post('activateUsers', {
          id: this.rider.id,
          active: active
        })
        .then(function(response) {
          that.rider.active = response.data.data.active
        })
        .catch(function(error) {
          // handle error
          that.$app.log(error)
        })
        .then(function() {
          that.loading = false
        })
    },
    lastKnownLocation: function(item) {
      let location = this.$_.last(item.lastKnownLocations)
      if (location) {
        return location
      } else {
        return {
          lastLatitude: 0,
          lastLongitude: 0
        }
      }
    },
    loadRider() {
      let that = this
      this.$refs.connectionManager.get('riders/' + this.$route.params.id, {
        onSuccess(response) {
          that.rider = response.data.data
          that.lat = parseFloat(that.lastKnownLocation(that.rider).lastLatitude)
          that.lng = parseFloat(
            that.lastKnownLocation(that.rider).lastLongitude
          )
          that.$app.log('lat' + that.lat)
          that.$app.log('lng' + that.lng)
          that.drawUserPath()
        }
      })
    },
    drawUserPath() {
      var flightPlanCoordinates = []
      this.rider.lastKnownLocations.forEach(element => {
        flightPlanCoordinates.push({
          lat: parseFloat(element.lastLatitude),
          lng: parseFloat(element.lastLongitude)
        })
      })
      if (this.riderPath !== null) {
        this.riderPath.setMap(null)
      }
      if (this.map !== null) {
        // eslint-disable-next-line no-unused-vars
        this.riderPath = new this.google.maps.Polyline({
          path: flightPlanCoordinates,
          geodesic: true,
          strokeColor: '#1A75BA',
          strokeOpacity: 1.0,
          strokeWeight: 3
        })
        this.riderPath.setMap(this.map)
      }
    }
  },
  watch: {
    $route(to, from) {
      this.loadRider()
    }
  },
  computed: {
    google: gmapApi,
    userIsActive: function(active) {
      return active === 1
    }
  },
  mounted() {
    let that = this
    this.$refs.mapRef.$mapPromise.then(map => {
      that.map = map
    })
    this.lat = this.latitude ? this.latitude : 0.0
    this.lng = this.longitude ? this.longitude : 0.0
    this.loadRider()
  }
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/RiderSiderBar.vue